import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlignCenterComponent } from "./med-icon-align-center.component";

@NgModule({
  declarations: [
    MedIconAlignCenterComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlignCenterComponent,
  ],
})
export class MedIconAlignCenterModule { }
